'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isSunday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isSunday.js
// module id = 242
// module chunks = 1